import { defineComponent as L, computed as f, createElementBlock as s, openBlock as i, createElementVNode as n, withDirectives as O, normalizeClass as A, createCommentVNode as l, createBlock as d, Fragment as D, createVNode as k, unref as r, normalizeStyle as b, mergeProps as E, toDisplayString as I, renderSlot as v, vShow as N } from "vue";
import { GuideIcon as C } from "@scalar-org/guide-icons";
import { ScalarIconCaretRight as S, ScalarIconArrowUpRight as V } from "@scalar/icons";
const z = { class: "sidebar-group-item" }, R = {
  key: 0,
  class: "sidebar-heading-chevron"
}, T = ["aria-controls", "aria-expanded"], G = { class: "sidebar-heading-link-title" }, U = {
  key: 2,
  class: "action-menu"
}, j = ["id"], K = /* @__PURE__ */ L({
  __name: "SidebarElement",
  props: {
    item: {},
    isActive: { type: Boolean },
    hasChildren: { type: Boolean },
    open: { type: Boolean },
    resolvePage: { type: Function }
  },
  emits: ["select", "toggleOpen"],
  setup(w, { emit: B }) {
    const t = w, a = B, F = f(() => {
      var o;
      const e = t.item;
      return e.type === "Link" ? {
        href: e.link,
        rel: "noopener noreferrer",
        target: "_blank"
      } : e.type === "Page" ? {
        href: ((o = t.resolvePage) == null ? void 0 : o.call(t, e.uid)) || "#"
      } : {};
    }), c = f(() => t.hasChildren || t.item.type === "Folder");
    function P() {
      if (t.item.type !== "Link") {
        if (t.item.type === "Folder") {
          a("toggleOpen");
          return;
        }
        a("select");
      }
    }
    function $() {
      t.item.type !== "Folder" && a("toggleOpen");
    }
    return (e, o) => {
      var p, m, u, g, y;
      return i(), s("li", z, [
        n("div", {
          class: A(["sidebar-heading", {
            active_page: e.isActive,
            "sidebar-group-item__folder": e.item.type === "Folder"
            /* Folder */
          }]),
          onClick: P
        }, [
          c.value ? (i(), s("p", R, [
            n("button", {
              "aria-controls": `${e.item.uid}-content`,
              "aria-expanded": e.open,
              class: "toggle-nested-icon",
              type: "button",
              onClick: $
            }, [
              o[1] || (o[1] = n("span", { class: "sr-only" }, "Toggle group", -1)),
              (m = (p = e.item) == null ? void 0 : p.icon) != null && m.src ? (i(), s(D, { key: 0 }, [
                k(r(C), {
                  class: "sidebar-icon",
                  src: e.item.icon.src
                }, null, 8, ["src"]),
                k(r(S), {
                  class: "sidebar-icon-caret hidden",
                  style: b({
                    transform: e.open ? "rotate(90deg)" : "rotate(0deg)"
                  }),
                  weight: "bold"
                }, null, 8, ["style"])
              ], 64)) : (i(), d(r(S), {
                key: 1,
                style: b({
                  transform: e.open ? "rotate(90deg)" : "rotate(0deg)"
                }),
                weight: "bold"
              }, null, 8, ["style"]))
            ], 8, T)
          ])) : l("", !0),
          n("a", E({ class: "sidebar-heading-link flex-1" }, F.value, {
            onClick: o[0] || (o[0] = (h) => e.item.type === "Link" ? h.stopPropagation() : h.preventDefault())
          }), [
            (g = (u = e.item) == null ? void 0 : u.icon) != null && g.src && !c.value ? (i(), d(r(C), {
              key: 0,
              class: "sidebar-icon",
              src: e.item.icon.src
            }, null, 8, ["src"])) : l("", !0),
            n("p", G, I(e.item.title.trim() || e.item.type), 1)
          ], 16),
          ((y = e.item) == null ? void 0 : y.type) === "Link" ? (i(), d(r(V), {
            key: 1,
            class: "link-icon",
            weight: "bold"
          })) : l("", !0),
          e.$slots["action-menu"] ? (i(), s("div", U, [
            v(e.$slots, "action-menu", {}, void 0, !0)
          ])) : l("", !0)
        ], 2),
        O(n("div", {
          id: `${e.item.uid}-content`,
          class: "contents"
        }, [
          v(e.$slots, "default", {}, void 0, !0)
        ], 8, j), [
          [N, e.open]
        ])
      ]);
    };
  }
});
export {
  K as default
};
